import { Trans, t } from '@lingui/macro';
import { Loader, useToast } from '@pocketlaw/tetris';
import { FileIcon } from './FileIcon';
import { StyledMenuItem } from './styled';
export function FileDownloadMenuItem(props) {
    const { file, loading, disabled, onBeforeDownload, onAfterDownload } = props;
    const { addToast } = useToast();
    const handleClick = () => {
        onBeforeDownload();
        addToast({
            title: t({
                message: `Downloading ${file.name}…`,
                comment: 'Toast message when the download has been initiated',
            }),
            appearance: 'info',
        });
        file.fetch().finally(() => onAfterDownload());
    };
    return (<StyledMenuItem disabled={disabled || loading} onClick={handleClick}>
      {loading ? <Loader /> : <FileIcon type={file.type}/>}
      <Trans comment="Dropdown label for downloading document in available formats">
        Download {file.name}
      </Trans>
    </StyledMenuItem>);
}
